import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Pizza, Lock, LogIn } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      sessionStorage.setItem('admin_token', data.token);
      onLogin(data);
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : 'Invalid email or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FFF8E7] flex items-center justify-center p-4">
      <div className="pizza-card p-8 w-full max-w-sm" data-testid="admin-login-card">
        <div className="text-center mb-6">
          <div className="w-14 h-14 bg-[#2A2A2A] rounded-full border-2 border-[#2A2A2A] flex items-center justify-center mx-auto mb-3 shadow-[3px_3px_0px_0px_rgba(42,42,42,0.3)]">
            <Lock className="w-6 h-6 text-white" />
          </div>
          <h1 className="text-3xl text-[#2A2A2A]" style={{ fontFamily: "'Bebas Neue', cursive" }} data-testid="admin-login-title">
            Admin Console
          </h1>
          <p className="text-sm text-[#2A2A2A]/50">Mikey Mozzarella's Pizza-lator</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="text-xs uppercase tracking-wider text-[#2A2A2A]/60 mb-1 block" style={{ fontFamily: "'Bebas Neue', cursive" }}>Email</label>
            <input type="email" required value={email} onChange={e => setEmail(e.target.value)}
              className="pizza-input w-full" placeholder="admin@example.com" data-testid="admin-email-input" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider text-[#2A2A2A]/60 mb-1 block" style={{ fontFamily: "'Bebas Neue', cursive" }}>Password</label>
            <input type="password" required value={password} onChange={e => setPassword(e.target.value)}
              className="pizza-input w-full" placeholder="Enter password" data-testid="admin-password-input" />
          </div>
          {error && <p className="text-sm text-[#E23D28]" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading} className="pizza-btn w-full flex items-center justify-center gap-2" data-testid="admin-login-btn">
            {loading ? 'Signing in...' : <><LogIn className="w-4 h-4" /> Sign In</>}
          </button>
        </form>
      </div>
    </div>
  );
}
